import { DemoStackInfo } from 'types/state';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createDemoStackInfo = (): DemoStackInfo => ({
  id: 0,
  subdomain: null,
  originURL: null,
  loginURL: null,
});

export const createDemoStackInfoMock = (): DemoStackInfo => ({
  id: createUniqueRuntimeNumber(),
  subdomain: 'demo13',
  originURL: 'https://demo13.fake.url',
  loginURL: 'https://demo13.fake.url/login',
});
